import React, { useEffect, useState } from 'react';
import { Form, Input, Select, Button, Spin, DatePicker } from 'antd';
import { getSelectOptionsWithOrWithoutImg } from '../../../utils/options';
// import ImageUploader from 'react-images-upload';
import ImageUploading from 'react-images-uploading';

import { UserOutlined } from '@ant-design/icons';
import styles from '../Profile.module.css';

import dayjs from "dayjs";
import { useContext } from 'react';
import { OrdinationsAndCountriesContext } from '../../../contexts/ordinationsAndCountriesContext';

const dateFormat = 'DD-MM-YYYY';
export const PersonalDetails = ({ initialData, updateUser }) => {
  const {  countries } = useContext(OrdinationsAndCountriesContext);
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [imageData, setImageData] = useState({
    image: null,
    imageChanged: false
  });
  useEffect(() => {
    const {  image, username } = initialData
    const {first_name,email,last_name,city,country,phone_number,address} = initialData['doctor'] ? initialData['doctor'] : initialData
    const birth_date = initialData['birth_date'] ? dayjs(new Date(initialData['birth_date'])) : null;
    form.setFieldsValue({
      email,
      image,
      first_name,
      last_name,
      city,
      country,
      phone_number,
      username,
      birth_date,
      address
    });
  }, [form, initialData]);
  const onSubmit = async (values) => {
    values.image = imageData.image;

    await updateUser(values);
  };
  const handleImageDrop = (image) => {
		const img = image[0]?.file

    setImageData({
      image: img,
      imageChanged: true
    });
  };
  const disabledDate = (current) => {
    const valide = dayjs().diff(current, 'years', true);
    return valide <= 18 || valide > 100;
  };

  const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
  };

  return (
    <div className={styles.personalDetailsContent}>
      <h2>
        <UserOutlined /> Uredi lične podatke
      </h2>
      <Spin spinning={loading} wrapperClassName={styles.personalDetailsContainer}>
        <Form {...layout}
          form={form}
          name="userForm"
          onFinish={onSubmit}
          onFinishFailed={({ errorFields }) => {
            form.scrollToField(errorFields[0].name);
          }}
					labelCol={{ span: 10 }}
					wrapperCol={{ span: 14 }}
        >
          <div className={styles.personalDetailsTop}>
            <div className={styles.imageUpload}>
              {imageData.image ? (
                <div className="imagePreviewModal">
                  <img src={URL.createObjectURL(imageData.image)} alt="Preview" className={styles.imageWidth} />
                </div>
              ) : initialData && initialData.image ? (
                <div className="imagePreviewModal">
                  <img src={initialData.image} alt="Preview" className={styles.imageWidth} />
                </div>
              ) : null}

							{/*
              <ImageUploader
                className="imageUploaderModal"
                buttonText="Upload"
                imgExtension={['.jpg', '.jpeg', '.png']}
                singleImage
                withLabel={false}
                onChange={handleImageDrop}
                withIcon={false}
              />
							*/}
							<ImageUploading
								multiple={false}
								acceptType={['jpg', 'jpeg', 'png']}
								onChange={handleImageDrop}
								maxNumber={1}
								dataURLKey="data_url"
							>
								{({ onImageUpload }) => (
									<div className={styles.imageUploaderModal}>
										<div className={styles.btn} onClick={onImageUpload}>
											Upload
										</div>
									</div>
								)}
							</ImageUploading>
            </div>

            <div className={styles.userInfo + ' ' + styles.personalDetailsBottom + ' ' + styles.personalBottomRight}>
              <p className={styles.centerAlign} >Informacije o korisniku</p>
              <Form.Item
                label="Ime"
                name="first_name"
                className={styles.fullWidth}
                
              >
                <Input
                  placeholder="Ime"
                  disabled
                />
              </Form.Item>
              <Form.Item
                label="Prezime"
                name="last_name"
                className={styles.fullWidth}
              >
                <Input
                  placeholder="Prezime"
                  disabled
                />
              </Form.Item>
              <div className={styles.contactBlock}>
                <Form.Item
                  label="Korisničko ime"
                  name="username"
                  className={styles.fullWidth} 
                  rules={[
                    {
                      max: 20,
                      message: "Username mora sadržiti 20 ili manje karaktera ",
                    },
                    {
                      required: true,
                      message: 'Popunite polje!'
                    }
                  ]}
                >
                  <Input
                    placeholder="Korisničko ime"
                   
                  />
                </Form.Item>
              </div>

              <Form.Item
                label="e-mail"
                name="email"
                rules={[
                  {
                    max: 40,
                    message: "E-mail mora sadržiti 40 ili manje karaktera ",
                  },

                  {
                    type: "email",
                    message: "Unešeni e-mail nije ispravan",
                  },
                  {
                    required: true,
                    message: 'Popunite polje!'
                  }
                ]}
              >
                <Input placeholder="e-mail adresa" maxLength={40} />
              </Form.Item>
              <Form.Item
                label="Broj telefona"
                name="phone_number"

                rules={[
                  {
                    max: 30,
                    message:
                      "Broj telefona mora sadržiti 30 ili manje karaktera ",
                  },
                ]}
              >
                <Input placeholder="Broj telefona" maxLength={30} />
              </Form.Item>
              <Form.Item
                label="Adresa"
                name="address"
                maxLength={40}
                rules={[
                  {
                    max: 40,
                    message: "Adresa mora sadržiti 40 ili manje karaktera ",
                  },
                ]}
              >
                <Input maxLength={40} placeholder="Adresa" autoComplete="off" />
              </Form.Item>
              <Form.Item
                label="Grad"
                name="city"
                normalize={(value) =>
                  (value || "").replace(/[^a-zA-Za-åa-ö-w-я ]+/g, "")
                }
                rules={[
                  {
                    max: 20,
                    message: "Grad mora sadržiti 20 ili manje karaktera ",
                  },
                ]}
              >
                <Input maxLength={20} placeholder="Grad" autoComplete="off" />
              </Form.Item>
              <Form.Item
                label="Država"
                name="country"
                className={styles.fullWidth}
                rules={[
                ]}
              >
                <Select
                  showSearch
                  dropdownClassName={countries ? styles.selectDropdownWithImg : styles.hideSelectDropdown}
                  optionFilterProp="data-searchvalue"
                  showArrow={false}
                  placeholder="Izaberite zemlju"
                  notFoundContent={'Nema rezultata'}
                >
                  {getSelectOptionsWithOrWithoutImg(countries || [])}
                </Select>
              </Form.Item>
              <Form.Item>
                <Button className={styles.confirmInfoChangesBtn} type="primary" htmlType="submit">
                  Sačuvaj izmjene
                </Button>
              </Form.Item>
            </div>
          </div>
        </Form>
      </Spin>
    </div>
  );
};
